import PropTypes from 'prop-types'

export const classNamePropTypes = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.objectOf(PropTypes.bool),
  PropTypes.arrayOf(PropTypes.string)
])
